module.exports = __webpack_public_path__ + "img/LKW_K_9t.9b694f2b.svg";